const translations = {
  "en": {
    "Brief": "Brief",
    "Desk": "Desk",
    "Discover": "Discover",
    "Goal": "Goal",
    "Invest": "Invest",
    "Missions": "Missions",
    "News": "News",
    "Plan": "Plan",
    "Subscriptions": "Subscriptions",
    "Track": "Track"
  },
  "zh-tw": {
    "Brief": "簡要",
    "Desk": "追蹤",
    "Discover": "發現",
    "Goal": "目標",
    "Invest": "投資",
    "Missions": "任務",
    "News": "新聞",
    "Plan": "方案",
    "Subscriptions": "訂閱",
    "Track": "追蹤"
  }
};

export default translations;
